import { render, staticRenderFns } from "./QuoteStateCard.vue?vue&type=template&id=2e4580b5&"
import script from "./QuoteStateCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports